/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { ReactNode } from "react";

import ActiveIcon from "../../../../shared/icons/general/Check.svg";
import NavigationIcon from "../../../../shared/icons/navigation/Chevron_right.svg";

import { useActiveSection } from "./ActiveSectionContext";

import "./DropdownMenuItem.scss";

interface DropdownMenuItemProps {
  active?: boolean;
  onItemSelect?: () => void;
  navigateToSection?: string;
  resetToDefaultSectionAfterSelect?: boolean;
  showActiveIcon?: boolean;
  sideText?: string;
  children: ReactNode;
  seasonId?: string;
}
export const DropdownMenuItem = (props: DropdownMenuItemProps) => {
  const {
    active,
    navigateToSection,
    resetToDefaultSectionAfterSelect = false,
    showActiveIcon = false,
    onItemSelect,
    sideText,
    children,
    seasonId,
  } = props;

  const { setSection, resetToDefault, setSeason } = useActiveSection();

  const onClick = () => {
    if (navigateToSection) {
      seasonId && setSeason(seasonId);
      return setSection(navigateToSection);
    }

    onItemSelect?.();
    resetToDefaultSectionAfterSelect && resetToDefault();
  };

  return (
    <div className="DropdownMenuItem" onClick={onClick}>
      <div className="DropdownMenuItem__Content">
        {showActiveIcon && (
          <div className="DropdownMenuItem__Content__ActiveIcon">
            {active && <ActiveIcon aria-hidden="true" focusable="false" />}
          </div>
        )}
        {children}
      </div>
      {sideText && (
        <div className="DropdownMenuItem__Side">
          {sideText}
          <NavigationIcon aria-hidden="true" focusable="false" />
        </div>
      )}
    </div>
  );
};
